var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6H21M11 12H21M11 18H21M5 9V3L3 5M5 9H3M5 9H7M3 16C3 15.7153 3.06078 15.4339 3.17827 15.1746C3.29577 14.9153 3.46727 14.684 3.68131 14.4963C3.89535 14.3086 4.147 14.1688 4.41943 14.0861C4.69186 14.0035 4.9788 13.98 5.26105 14.0171C5.54331 14.0543 5.81438 14.1513 6.05614 14.3016C6.2979 14.4519 6.50477 14.6521 6.66294 14.8889C6.8211 15.1256 6.92691 15.3933 6.97329 15.6742C7.06369 16.2218 6.71035 16.7138 6.29491 17.0818L3 20H7",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListNumber);
export default __webpack_public_path__ + "static/media/list-number.0858c80d54219364d01674f966a19f25.svg";
export { ForwardRef as ReactComponent };